/* eslint-disable semi */
import $ from 'jquery'
import Masonry from 'masonry-layout'

const grid = document.querySelector('.postGrid')
let msnry

function init() {

    $(document).on('facetwp-loaded', () => {

        msnry = new Masonry( grid, {
            itemSelector: '.postGrid-item',
            columnWidth: '.grid-sizer',
            gutter: '.gutter-sizer',
            percentPosition: true,
        })
    })

}

export default {
    init,
}